// extracted by mini-css-extract-plugin
export default {"title":"ProposalTitle_title__ageZH","boxStyled":"ProposalTitle_boxStyled__Uw2Pf"};